/* HAZAR — hz-head.js (سرعة الموبايل 2026-09-08، البند #12)
   الجزآن هون كانا مضمَّنين بالـ<head> وكانا أصلًا ينتظران DOMContentLoaded، فنقلهما لملف defer
   ما بيغيّر توقيتهما إطلاقًا (defer بيشتغل بعد تحليل الوثيقة وقبل DOMContentLoaded) — بس بيوقف
   إرسالهما مع كل صفحة وبيفكّ حجزهما لمحلّل HTML. بيتحمّل قبل hz-v7.js وبنفس ترتيبه.
   ═══ 1) زر «أضيفي للسلة» على كل بطاقة + ترجمة الخامة/بلد الصنع للعرض ═══ */
(function(){
  /* زر أضيفي للسلة على كل بطاقة (يفتح نافذة اختيار المقاس) */
  function addBtns(root){
    (root||document).querySelectorAll('.hdt-card-product').forEach(function(card){
      if(card.querySelector('.hz-atc')) return;
      var info=card.querySelector('.hdt-card-product__info'); if(!info) return;
      var b=document.createElement('button'); b.type='button'; b.className='hz-atc';
      b.textContent='أضيفي للسلة';
      b.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        var qv=card.querySelector('.hdt-card-product__btn-quick-view');
        if(qv){ qv.click(); return; }
        var t=card.querySelector('.hdt-card-product__title'); if(t){ t.click(); }
      });
      info.appendChild(b);
    });
  }
  /* ترجمة الخامة/بلد الصنع للعربي — للعرض فقط (بيانات النظام تظل كما هي للمزامنة) */
  var M={leather:'جلد',textile:'قماش',lycra:'ليكرا',chamois:'شامواه',suede:'شامواه',synthetic:'صناعي',rubber:'مطاط',canvas:'كانفاس',mesh:'شبك',patent:'لميع',lace:'دانتيل',velvet:'مخمل',satin:'ساتان',denim:'دنيم',cotton:'قطن',nubuck:'نوبوك',pu:'جلد صناعي',eva:'إيفا',china:'الصين',syria:'سوريا',turkiye:'تركيا',turkey:'تركيا',vietnam:'فيتنام',india:'الهند',italy:'إيطاليا',egypt:'مصر',indonesia:'إندونيسيا',bangladesh:'بنغلاديش',pakistan:'باكستان',thailand:'تايلاند',cambodia:'كمبوديا',spain:'إسبانيا',france:'فرنسا',brazil:'البرازيل',portugal:'البرتغال',morocco:'المغرب',korea:'كوريا'};
  var RE=new RegExp('\\b('+Object.keys(M).join('|')+')\\b','gi');
  function trDesc(root){
    (root||document).querySelectorAll('.hdt-product__description,.hdt-rte,[class*=description]').forEach(function(el){
      var wk=document.createTreeWalker(el,NodeFilter.SHOW_TEXT); var ns=[]; var nn;
      while(nn=wk.nextNode()) ns.push(nn);
      ns.forEach(function(t){
        var v=t.nodeValue;
        if(/kalles/i.test(v)){ t.nodeValue=''; return; } /* يشيل نص Kalles التجريبي */
        var nv=v.replace(RE,function(m){ return M[m.toLowerCase()]||m; });
        if(nv!==v) t.nodeValue=nv;
      });
    });
  }
  function run(){ addBtns(document); trDesc(document); }
  var timer=null;
  function schedule(){ if(timer) return; timer=setTimeout(function(){ timer=null; run(); },150); }
  function init(){
    run();
    /* r59: المرسل الموحّد (يحافظ على دفعه 150ms) */
    try{ window.hzOnAdded(schedule); }catch(e){}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();

/* ═══ 2) توحيد أيقونات الدفع (الفوتر + صفحة السلة + الدرج) ═══ */
(function(){
  /* v7: الأيقونات مستضافة كأصول داخل الثيم (بدل GitHub — أسرع وبلا حظر إقليمي) */
  var ICONS=window.hzIcons; if(!ICONS) return;  /* الروابط تُطبع بالـhead لأن Liquid ما بيشتغل جوّا ملف .js */
  var ORDER=["visa","master","knet","apple_pay","google_pay"];
  var PAY=/visa|paypal|master|amex|american_express|amazon|knet|apple_pay|google_pay|discover|diners/i;
  function rowHTML(){ return ORDER.map(function(n){ return '<img class="hz-pay-ic" alt="'+n+'" src="'+ICONS[n]+'">'; }).join(""); }
  function rowOf(img){ var e=img; while(e&&e.parentElement&&e!==document.body){ var p=e.parentElement; var n=0; p.querySelectorAll("img").forEach(function(x){ if(PAY.test(x.getAttribute("src")||"")) n++; }); if(n>=2) return p; e=p; } return img.parentElement; }
  function normalize(){
    var rows=[]; document.querySelectorAll("img").forEach(function(im){ if(PAY.test(im.getAttribute("src")||"")){ var r=rowOf(im); if(r&&rows.indexOf(r)<0) rows.push(r); } });
    rows.forEach(function(row){ if(row.classList&&row.classList.contains("hz-footer-pay")) return; if(row.__hzPay) return; row.__hzPay=true; row.innerHTML=rowHTML(); });
  }
  function footer(){ if(document.querySelector(".hz-footer-pay")) return; var f=document.querySelector("footer"); if(!f) return; var row=document.createElement("div"); row.className="hz-footer-pay"; row.innerHTML=rowHTML(); var a=f.querySelector(".hz-footer-bottom")||f; a.insertBefore(row,a.firstChild); }
  var t=null; function run(){ try{ footer(); normalize(); }catch(e){} }
  function sched(){ if(t) return; t=setTimeout(function(){ t=null; run(); },150); }
  function init(){ run(); var n=0; var iv=setInterval(function(){ run(); if(++n>10) clearInterval(iv); },400); /* r59: المرسل الموحّد */ try{ window.hzOnAdded(sched); }catch(e){} }
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",init); } else { init(); }
})();
